import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { proCheck } from '~teacher/util/proCheck';

import { CommonProps, ExportReportPanel } from './ExportReportPanel';
import { IncludeExplanations, ReportOptionType } from './ReportOption';

const ExportReportsAnswerKey = (props: CommonProps) => {
  const reportOptions: ReportOptionType[] = [IncludeExplanations];
  const canCustomizeExportResults = proCheck.canCustomizeExportResults();
  return (
    <ExportReportPanel
      {...props}
      shouldShowProBadgeInHeader={!canCustomizeExportResults}
      shouldShowProBadge={false}
      shouldShowPaywallOnReportsButtonClicked={!canCustomizeExportResults}
      description={translate('Export a PDF of the correct quiz answers.')}
      title={translate('Answer Key')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.EmptyQuiz}
    />
  );
};

export { ExportReportsAnswerKey };
export default ExportReportsAnswerKey;
